import React, { useEffect, useState } from "react";
import FileUpload from "../../components/Employee/OfficialBusiness/FileUpload";
import LeaveTypeSelect from "../../components/Employee/Leave/LeaveTypeSelect";
import LeaveDateRange from "../../components/Employee/Leave/DateRange";
import LeavePayDays from "../../components/Employee/Leave/PayDays";
import LeaveOptions from "../../components/Employee/Leave/Options";
import LeaveReason from "../../components/Employee/Leave/Reason";
import {
  useCreateLeaveRequest,
  useGetAllMyEmployeeLeaveCredits,
} from "../../hooks/useLeave";
import { useCreateMedia } from "../../hooks/useMedia";
import { computeDays, EMPLOYEE_MEDIA_REFERENCE } from "../../util/common";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ReasonField from "../../components/Employee/OfficialBusiness/ReasonField";

function LeaveApplicationLayout() {
  const leaveRequest = useCreateLeaveRequest();
  const leaveCredits = useGetAllMyEmployeeLeaveCredits();

  const fileMediaUpload = useCreateMedia();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    leaveType: "",
    startDate: "",
    endDate: "",
    withPay: "",
    withoutPay: "",
    option: "FullDay",
    halfType: "",
    reason: "",
  });

  const [stateLeaveTypes, setStateLeaveTypes] = useState([]);
  const [fileAttached, setFileAttached] = useState(null);

  const handleFileUpload = async () => {
    if (!fileAttached) return null;

    const formDataFile = new FormData();
    formDataFile.append("ReferenceType", EMPLOYEE_MEDIA_REFERENCE);
    formDataFile.append("File", fileAttached);

    return new Promise((resolve, reject) => {
      fileMediaUpload.mutate(formDataFile, {
        onSuccess: (data) => {
          if (data.success) {
            resolve(data?.data?.id);
          } else {
            resolve(null);
          }
        },
        onError: (err) => {
          reject(err);
        },
      });
    });
  };

  const handleChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let mediaID = null;

    if (fileAttached) {
      mediaID = await handleFileUpload();
    }
    const days = computeDays(form.startDate, form.endDate, form.option);

    const finalPayload = {
      leaveTypeID: form.leaveType ? parseInt(form.leaveType) : 0,
      requestType: form.option === "HalfDay" ? form.halfType : form.option,
      durationDays: days,
      reason: form.reason,
      mediaID: mediaID,
      startDate: form.startDate,
      endDate: form.endDate,
    };

    leaveRequest.mutate(finalPayload, {
      onSuccess: (data) => {
        if (data && data.success) {
          toast.success(data.message);
          return navigate("/LeavesList");
        }
      },
      onError: (er) => {
        return toast.error("Error occurred");
      },
    });
  };

  const getAllEmployeeLeaveCredits = async () => {
    leaveCredits.mutate(undefined, {
      onSuccess: (data) => {
        if (data && data.success) {
          const _type = data.data.map((d) => {
            if (d && d.LeaveType) {
              return {
                id: d.id,
                name: d.LeaveType.Name,
                paid: d.LeaveType.IsPaid,
                remaining: d.Remaining,
              };
            }
          });
          setStateLeaveTypes(_type);
        }
      },
    });
  };

  useEffect(() => {
    const selectedType = stateLeaveTypes.find((lt) => lt.id == form.leaveType);

    if (!selectedType) return;

    const days = computeDays(form.startDate, form.endDate, form.option);

    if (selectedType.paid) {
      setForm((prev) => ({
        ...prev,
        withPay: days,
        withoutPay: 0,
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        withPay: 0,
        withoutPay: days,
      }));
    }
  }, [form.startDate, form.endDate, form.leaveType, form.option]);

  useEffect(() => {
    getAllEmployeeLeaveCredits();
  }, []);

  return (
    <div className="overtime-form-container">
      <h2>Leave Application Form</h2>

      <form className="leave-form" onSubmit={handleSubmit}>
        <LeaveTypeSelect
          value={form.leaveType}
          onChange={(v) => handleChange("leaveType", v)}
          choices={stateLeaveTypes}
        />

        <LeaveDateRange
          startDate={form.startDate}
          endDate={form.endDate}
          onChange={handleChange}
        />

        <LeavePayDays
          withPay={form.withPay}
          withoutPay={form.withoutPay}
          onChange={handleChange}
          disabled={true}
        />

        <LeaveOptions
          option={form.option}
          halfType={form.halfType}
          onChange={handleChange}
        />

        <FileUpload onUpload={(file) => setFileAttached(file)} />

        <ReasonField
          value={form.reason}
          onChange={(v) => handleChange("reason", v)}
          fieldName={"Leave Application"}
        />

        <button type="submit" className="submit-btn">
          Submit
        </button>
      </form>
    </div>
  );
}

export default LeaveApplicationLayout;
